export default {
  root: () => ({
    class: ['radiobutton-root']
  }),
  box: ({ instance, context }) => {
    const variant = instance?.variant || 'secondary';
    const size = instance?.size || 'sm';
    return {
      class: [
        'radiobutton-box',
        {
          'radiobutton-box_primary': variant === 'primary',
          'radiobutton-box_secondary': variant === 'secondary',
          'radiobutton-box_disabled': context.disabled,
          'radiobutton-box_checked': context.checked,
          'radiobutton-box_invalid': context.invalid,
          'radiobutton-box_md': size === 'md',
        }
      ]
    };
  },
  icon: ({ instance }) => {
    const variant = instance?.variant || 'secondary';
    return {
      class: [
        variant === 'secondary' && 'radiobutton-box_secondary-dot'
      ]
    };
  },
  input: {
    class: ['radiobox-input']
  },
};
